export const fr = {
  'ad.label': 'Publicité',
  'ad.sponsored_by': 'Sponsorisé par {advertiser}',
  'ad.visit': 'Visiter',
  'cookies.preferences': 'Préférences de cookies',
  'cookies.title': 'Votre vie privée, sous votre contrôle',
  'cookies.description': 'Nous utilisons un stockage nécessaire au fonctionnement d\'Albambam. Nous n\'activerons l\'analytique ou le marketing qu\'avec votre permission. Vous pouvez la retirer à tout moment. Consultez la',
  'cookies.privacy_link': 'Politique de confidentialité',
  'cookies.close': 'Fermer les préférences',
  'cookies.necessary': 'Nécessaires',
  'cookies.necessary_desc': 'Session, sécurité, langue et préférences de base.',
  'cookies.analytics': 'Analytique',
  'cookies.analytics_desc': 'Mesure anonyme de l\'utilisation pour améliorer le service.',
  'cookies.marketing': 'Marketing',
  'cookies.marketing_desc': 'Personnalisation publicitaire et mesure des campagnes.',
  'cookies.configure': 'Configurer',
  'cookies.reject': 'Refuser les optionnels',
  'cookies.save': 'Enregistrer la sélection',
  'cookies.accept': 'Tout accepter',
  'lang.selector_label': 'Langue',
  'lang.changed': 'Langue changée',
  'nav.home': 'Accueil',
  'nav.categories': 'Catégories',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Amitiés',
  'nav.upload': 'Publier',
  'nav.profile': 'Profil',
  'nav.login': 'Connexion',
  'common.signed_in': 'Connecté',
  'common.error': 'Erreur',
  'topbar.search_placeholder': 'Rechercher des vidéos, créateurs...',
  'legal.terms': 'Conditions',
  'legal.privacy': 'Confidentialité',
  'nav.admin': 'Administration',
  'nav.logout': 'Se déconnecter',
  'admin.tab.payments': 'Paiements',
  'admin.payments.title': 'Paiements',
  'cats.title': 'Catégories',
  'cats.all': 'Toutes',
  'cats.adult_title': 'Catégories +18',
  'cats.empty': 'Aucune vidéo dans cette catégorie.',
  'friends.block_confirm': 'Bloquer cet ami ? Vous ne pourrez plus discuter ni vous voir en tant qu\'amis.',
  'friends.accepted': 'Vous êtes maintenant amis !',
  'friends.title': 'Amitiés',
  'friends.subtitle': 'Seuls ceux qui se suivent mutuellement deviennent amis et peuvent discuter en privé.',
  'friends.unread_count_label': '{n} messages à lire',
  'friends.blocked_users_title': 'Utilisateurs bloqués',
  'friends.unblock_user': 'Débloquer',
  'friends.requests_title': 'Demandes de chat',
  'friends.request_badge': 'Demande',
  'friends.request_accept': 'Accepter',
  'friends.request_ignore': 'Ignorer',
  'friends.empty_title': 'Vous n\'avez pas encore d\'amis',
  'friends.empty_subtitle': 'Suivez quelqu’un et faites-vous suivre en retour pour débloquer le chat privé.',
  'friends.attach_image': 'Photo',
  'friends.shared_video_label': 'A partagé une vidéo',
  'friends.select_conversation': 'Sélectionnez un ami pour commencer à discuter',
  'friends.block_user': 'Bloquer',
  'friends.no_messages_yet': 'Pas encore de messages. Dites bonjour !',
  'friends.message_placeholder': 'Écrivez un message...',
  'section.trending': 'Tendances',
  'section.shorts': 'Shorts',
  'section.for_you': 'Pour vous',
  'home.hero.badge': 'Bienvenue sur Albambam',
  'home.hero.title_1': 'Vidéos courtes.',
  'home.hero.title_2': 'Créateurs réels.',
  'home.hero.subtitle': 'Regardez, partagez et gagnez. Publiez vos vidéos et découvrez de nouveaux talents dans chaque catégorie.',
  'home.hero.cta_shorts': 'Voir les Shorts',
  'home.hero.cta_trending': 'Tendances',
  'home.shorts.see_all': 'Tout voir',
  'home.empty.title': 'Pas encore de vidéos',
  'home.empty.subtitle': 'Lorsque les créateurs publieront du contenu, il apparaîtra ici.',
  'live.send_diamonds': 'Envoyer des diamants',
  'live.buy': 'Acheter',
  'live.chat': 'Chat',
  'live.type_message': 'Écrivez un message...',
  'live.send': 'Envoyer',
  'auth.success_google': 'Connecté avec Google',
  'auth.fail_google': 'Session Google invalide',
  'auth.success_login': 'Connecté',
  'auth.success_register': 'Compte créé',
  'auth.login_tab': 'Connexion',
  'auth.register_tab': 'Créer un compte',
  'auth.email': 'Adresse e-mail',
  'auth.password': 'Mot de passe',
  'auth.submit_login_loading': 'Connexion...',
  'auth.submit_login': 'Se connecter',
  'auth.name': 'Nom',
  'auth.submit_register_loading': 'Création...',
  'auth.submit_register': 'Créer un compte',
  'auth.or': 'ou',
  'legal.privacy_title': 'Politique de confidentialité',
  'search.title': 'Résultats pour « {q} »',
  'search.count': '{n} vidéos',
  'search.empty': 'Aucun résultat.',
  'series.load_error': 'Impossible de charger la série',
  'series.unlocked': 'Série débloquée',
  'series.purchase_error': 'Impossible de démarrer l\'achat',
  'series.restricted': 'Accès restreint',
  'series.configure_access': 'Configurer l\'accès',
  'series.language_all': 'Toutes les langues',
  'series.episode_count': '{n} épisodes',
  'series.buy': 'Acheter la série',
  'series.filter_language': 'Filtrer par langue',
  'series.no_episodes': 'Aucun épisode publié pour le moment.',
  'series.episode_number': 'Épisode {n}',
  'legal.terms_title': 'Conditions d\'utilisation',
  'lang.ca': 'Catalan',
  'lang.en': 'Anglais',
  'lang.es': 'Espagnol',
  'lang.fr': 'Français',
  'lang.de': 'Allemand',
  'lang.it': 'Italien',
  'lang.eu': 'Basque',
  'lang.gl': 'Galicien',
  'lang.zh': 'Chinois',
  'lang.other': 'Autre',
  'lang.vi': 'Vietnamien',
  'lang.ja': 'Japonais',
  'lang.ko': 'Coréen',
  'lang.ru': 'Russe',
  'lang.ro': 'Roumain',
  'lang.ar': 'Arabe',
  'lang.tr': 'Turc',
  'lang.pl': 'Polonais',
  'lang.ms': 'Malais',
  'lang.ta': 'Tamoul',
  'upload.series_title_error': 'Écrivez le titre de la série',
  'upload.series_adult_category_error': 'Sélectionnez une catégorie +18 pour la série',
  'upload.series_created': 'Série créée',
  'upload.series_create_error': 'Impossible de créer la série',
  'upload.err_file': 'Choisissez un fichier vidéo valide',
  'upload.err_title': 'Indiquez un titre',
  'upload.series_select_error': 'Sélectionnez ou créez une série',
  'upload.trailer_target_error': 'Sélectionnez la vidéo ou la série de la bande-annonce',
  'upload.price_error': 'Saisissez un prix valide d’au moins 0,50 EUR.',
  'upload.adult_category_error': 'Sélectionnez une catégorie adulte',
  'upload.success': 'Vidéo publiée avec succès',
  'upload.title_h': 'Publier une vidéo',
  'upload.kind': 'Type de publication',
  'upload.kind_video': 'Vidéo indépendante',
  'upload.kind_episode': 'Épisode d’une série',
  'upload.kind_trailer': 'Bande-annonce publique en Shorts',
  'upload.series': 'Série',
  'upload.series_select': 'Sélectionnez une série',
  'upload.episode': 'Épisode',
  'upload.series_new_title': 'Titre d’une nouvelle série',
  'upload.series_create': 'Créer une série',
  'upload.series_adult': 'Série +18',
  'upload.series_premium': 'Série premium',
  'upload.series_adult_category': 'Catégorie +18 de la série',
  'upload.series_price': 'Prix par épisode et pack (EUR)',
  'upload.trailer_for': 'La bande-annonce présente',
  'upload.trailer_select': 'Sélectionnez une vidéo ou une série',
  'upload.video_prefix': 'Vidéo',
  'upload.file_label': 'Fichier vidéo (MP4, max 1 Go)',
  'upload.file_pick': 'Cliquez pour choisir une vidéo',
  'upload.thumb_label': 'Miniature (facultatif)',
  'upload.video_title': 'Titre',
  'upload.description': 'Description',
  'upload.category': 'Catégorie',
  'upload.is_short': 'C’est un Short (vertical)',
  'upload.paid_video': 'Vidéo payante',
  'upload.adult_content': 'Contenu +18',
  'upload.video_language': 'Langue de la vidéo',
  'upload.individual_price': 'Prix pour regarder cette vidéo (EUR)',
  'upload.paid_video_help': 'Le spectateur achète un accès permanent uniquement à cette vidéo. Le prix minimum est de 0,50 EUR.',
  'upload.adult_category': 'Catégorie adulte',
  'upload.uploading': 'Envoi {n}%',
  'upload.submit': 'Publier la vidéo',
  'user.followers': 'abonnés',
  'user.following': 'abonnements',
  'user.follow': 'Suivre',
  'user.chat_open': 'Discuter',
  'user.request_sent': 'Demande envoyée',
  'user.send_message': 'Envoyer un message',
  'user.followers_title': 'Abonnés',
  'user.following_title': 'Abonnements',
  'user.unfollow': 'Ne plus suivre',
  'user.request_title': 'Demande de chat',
  'user.request_subtitle': 'Vous ne pouvez envoyer qu\'un seul message. S\'il accepte votre demande, vous deviendrez amis et pourrez discuter.',
  'user.request_placeholder': 'Écrivez votre message...',
  'user.request_send': 'Envoyer la demande',
  'shorts.login_for_like': 'Connectez-vous pour aimer',
  'watch.share_copied': 'Lien copié',
  'watch.delete_confirm': 'Supprimer ce commentaire ?',
  'ad.skip_in': 'Passer dans {n}s',
  'ad.skip': 'Passer la publicité',
  'watch.share': 'Partager',
  'friends.share_video': 'Partager une vidéo',
  'friends.send': 'Envoyer',
  'watch.comments': 'Commentaires',
  'watch.write_comment': 'Écrivez un commentaire...',
  'watch.publish': 'Publier',
  'watch.login_to_comment': 'Connectez-vous pour commenter.',
  'watch.login_btn': 'Connectez-vous pour commenter',
  'watch.no_comments': 'Pas encore de commentaires.',
  'watch.related': 'Similaires',
  'nav.trending': 'Tendances',
  'friends.follow_option_only_follow': 'Suivre',
  'friends.follow_option_friends': 'Amis',
  'watch.like': 'J\'aime',
  'watch.views_short': '{n} vues',
  'shorts.empty.title': 'Pas encore de Shorts',
  'shorts.empty.subtitle': 'Publiez une vidéo courte pour inaugurer la section.',
  'shorts.share': 'Partager',
  'auth.continue_google': 'Continuer avec Google',
  'upload.is_premium': 'Premium',
  'upload.price': 'Prix (€)',
  'upload.err_select': 'Choisissez une vidéo',
  'profile.upload_btn': 'Publier une vidéo',
  'profile.tab_videos': 'Mes vidéos ({n})',
  'profile.tab_history': 'Historique',
  'profile.tab_recos': 'Recommandations',
  'profile.no_videos': 'Vous n\'avez pas encore publié de vidéo.',
  'profile.no_history': 'Vous n\'avez pas encore regardé de vidéo.',
  'profile.no_recos': 'Regardez quelques vidéos pour recevoir des recommandations.',
  'profile.likes': 'j\'aime',
  'profile.views': 'vues',
  'wallet.title': 'Portefeuille',
  'wallet.rate_label': 'Taux',
  'wallet.min_label': 'Retrait minimum',
  'wallet.amount_label': 'Montant à retirer',
  'wallet.withdraw_btn': 'Demander un retrait',
  'wallet.history_title': 'Historique des demandes',
  'wallet.success': 'Demande créée',
  'wallet.bad_amount': 'Montant invalide',
  'wallet.per_view': '{rate} {cur}/vue',
  'admin.title': 'Administration',
  'admin.stats.users': 'Utilisateurs',
  'admin.stats.videos': 'Vidéos',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Vues',
  'admin.tab.videos': 'Vidéos',
  'admin.tab.ads': 'Annonces',
  'admin.tab.users': 'Utilisateurs',
  'admin.tab.withdrawals': 'Retraits',
  'admin.tab.config': 'Configuration',
  'admin.tab.translations': 'Langues',
  'tbl.title': 'Titre',
  'tbl.creator': 'Créateur',
  'tbl.category': 'Catégorie',
  'tbl.type': 'Type',
  'tbl.views': 'Vues',
  'tbl.likes': 'J\'aime',
  'tbl.status': 'Statut',
  'tbl.actions': 'Actions',
  'tbl.placement': 'Position',
  'tbl.advertiser': 'Annonceur',
  'tbl.impressions': 'Imp.',
  'tbl.clicks': 'Clics',
  'tbl.active': 'Actif',
  'tbl.name': 'Nom',
  'tbl.email': 'E-mail',
  'tbl.role': 'Rôle',
  'tbl.wallet': 'Portefeuille',
  'tbl.amount': 'Montant',
  'tbl.date': 'Date',
  'tbl.user': 'Utilisateur',
  'video.video': 'Vidéo',
  'video.short': 'Short',
  'action.show': 'Publier',
  'action.hide': 'Masquer',
  'action.delete_confirm_video': 'Supprimer la vidéo ?',
  'ad.create_h': 'Créer une annonce',
  'ad.title_label': 'Titre',
  'ad.image_label': 'URL de l’image',
  'ad.target_label': 'URL de destination',
  'ad.advertiser_label': 'Annonceur',
  'ad.placement_label': 'Emplacement',
  'ad.placement.banner': 'Bannière (site web)',
  'ad.placement.preroll': 'Pre-roll (avant la vidéo)',
  'ad.placement.overlay': 'Overlay (dans la vidéo)',
  'ad.active': 'Actif',
  'ad.create_btn': 'Créer',
  'ad.success_create': 'Annonce créée',
  'ad.delete_confirm': 'Supprimer l’annonce ?',
  'users.make_admin': 'Rendre admin',
  'users.remove_admin': 'Retirer l\'admin',
  'wd.approve': 'Approuver',
  'wd.reject': 'Rejeter',
  'wd.mark_paid': 'Marquer payé',
  'wd.empty': 'Aucune demande',
  'cfg.title': 'Configuration des paiements',
  'cfg.rate_label': 'Paiement par vue ({cur})',
  'cfg.min_label': 'Minimum de retrait ({cur})',
  'cfg.currency': 'Devise',
  'cfg.save': 'Enregistrer',
  'cfg.saved': 'Configuration enregistrée',
  'trans.title': 'Langues et traductions',
  'trans.intro': 'Téléversez un fichier JSON avec des traductions pour n’importe quel code de langue (p. ex. ja, pt, zh). Le fichier doit contenir un mappage plat clé → texte.',
  'trans.code_label': 'Code de langue (p. ex. ja, pt-BR, zh)',
  'trans.name_label': 'Nom (dans cette langue)',
  'trans.file_label': 'Fichier JSON de traductions',
  'trans.upload': 'Téléverser',
  'trans.uploaded': 'Traductions enregistrées',
  'trans.delete': 'Supprimer',
  'trans.delete_confirm': 'Supprimer cette langue ?',
  'trans.builtin': 'Intégré',
  'trans.custom': 'Personnalisé',
  'trans.empty_custom': 'Pas encore de langues personnalisées.',
  'common.cancel': 'Annuler',
  'common.loading': 'Chargement...',
  'common.too_fast': 'Trop rapide, attendez un instant',
  'time.few_seconds': 'il y a quelques secondes',
  'time.min': 'il y a {n} min',
  'time.h': 'il y a {n} h',
  'time.d': 'il y a {n} j',
  'time.w': 'il y a {n} sem',
  'time.mo': 'il y a {n} mois',
  'time.y': 'il y a {n} an',
  'brand.tagline': 'Vidéos courtes. Créateurs réels.',
  'live.section': 'En direct',
  'live.start': 'Démarrer un direct',
  'live.end': 'Terminer le direct',
  'live.join': 'Rejoindre le direct',
  'live.chat_placeholder': 'Écrivez un message...',
  'live.diamond': 'Diamant',
  'live.buy_access': 'Acheter l\'accès',
  'live.save_recording': 'Enregistrer l\'enregistrement',
};
